const JOURNEY_KEY = 'tb-journey-claim-collapsed';
const CLAIMED_BY_OTHERS_KEY = 'tb-claimed-by-others-collapsed';
const RECENTLY_ADDED_KEY = 'tb-recently-added-collapsed';

const writeCollapsed = (key: string, collapsed: boolean): void => {
  try {
    localStorage.setItem(key, collapsed ? '1' : '0');
  } catch {
    /* ignore quota / private mode */
  }
};

/** Whether the Complete a Journey edit section is collapsed (persisted). Defaults collapsed. */
export const getJourneyClaimCollapsed = (): boolean => {
  try {
    return localStorage.getItem(JOURNEY_KEY) !== '0';
  } catch {
    return true;
  }
};

export const setJourneyClaimCollapsed = (collapsed: boolean): void => writeCollapsed(JOURNEY_KEY, collapsed);

/** Whether the Claimed by others edit section is collapsed (persisted). Defaults collapsed. */
export const getClaimedByOthersCollapsed = (): boolean => {
  try {
    return localStorage.getItem(CLAIMED_BY_OTHERS_KEY) !== '0';
  } catch {
    return true;
  }
};

export const setClaimedByOthersCollapsed = (collapsed: boolean): void =>
  writeCollapsed(CLAIMED_BY_OTHERS_KEY, collapsed);

/** Whether the Recently added edit section is collapsed (persisted). Defaults collapsed. */
export const getRecentlyAddedCollapsed = (): boolean => {
  try {
    return localStorage.getItem(RECENTLY_ADDED_KEY) !== '0';
  } catch {
    return true;
  }
};

export const setRecentlyAddedCollapsed = (collapsed: boolean): void => writeCollapsed(RECENTLY_ADDED_KEY, collapsed);
